import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useUpdateProfile } from 'data/profiles'
import Button from 'Components/Ui-Kits/Buttons'
import { Colors } from 'constants/colors'
import styled from 'styled-components'

export const Edit = ({ value }) => {
  const { t } = useTranslation()
  const [updateProfile, loading] = useUpdateProfile(value)

  return (
    <ButtonsWrap>
      <Button
        disabled={loading}
        color={Colors.MAROON}
        maxWidth={120}
        style={{ height: 30, fontSize: 12 }}
        onClick={() => {
          const note = prompt(t('note'))
          updateProfile({ maxBiddingLevel: -1, maxBiddingLevelIncreaseRequested: null, note })
        }}
      >
        {t('accept')}
      </Button>
      <Button
        disabled={loading}
        secondary
        color={Colors.MAROON}
        maxWidth={120}
        style={{ height: 30, fontSize: 12 }}
        onClick={() => {
          const note = prompt(t('note'))
          updateProfile({ maxBiddingLevelIncreaseRequested: null, note })
        }}
      >
        {t('decline')}
      </Button>
    </ButtonsWrap>
  )
}

const ButtonsWrap = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  gap: 8px;
`

Edit.propTypes = {
  value: PropTypes.string,
}
